export const GET_ADVERTISEMENT = "GET_ADVERTISEMENT";
export const EDIT_ADVERTISEMENT = "EDIT_ADVERTISEMENT";
export const SHOW_ADVERTISEMENT = "SHOW_ADVERTISEMENT";
